<template>
  <div>
    <v-app>
      <router-view v-if="!$store.state.app.waitingForConnection" />
      <offline v-else />
    </v-app>
  </div>
</template>
<script>
import Offline from '@/views/Offline';

export default {
  name: 'App',
  components: {
    Offline,
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    online() {
      return this.$store.state.app.online;
    },
    isLoading() {
      return this.$store.state.app.isLoading;
    },
  },
  methods: {
    checkConnection() {
      if (this.online === false) {
        this.$toast.show(this.$t('offline.message'), this.$t('offline.title'));
        // HACK - the following check prevents iziToast to try to hide a null
        // toast, which provokes an error.
      } else if (document.querySelector('.iziToast')) {
        this.$toast.hide();
      }
    },
    async logout() {
      try {
        await this.$store.dispatch('auth/LOG_OUT');
      } catch (error) {
        console.error(error.message);
      }
      this.$router.push('/login');
    },
  },
  watch: {
    locale(newValue) {
      if (newValue) {
        localStorage.setItem('locale', this.locale);
      }
    },
    online: {
      immediate: false,
      handler() {
        this.checkConnection();
      },
    },
  },
  async mounted() {
    /**
     * APPLICATION BOOTSTRAP -- refactor this in a service if necessary.
     */
    this.$kuzzle.addListener('connected', () => {
      this.$store.commit('app/SET_ONLINE');
    });
    this.$kuzzle.addListener('reconnected', () => {
      this.$store.commit('app/SET_ONLINE');
    });
    this.$kuzzle.addListener('disconnected', () => {
      this.$store.commit('app/SET_OFFLINE');
    });
    this.$kuzzle.addListener('tokenExpired', () => {
      this.$store.dispatch('auth/LOG_OUT');
      this.$router.push({ name: 'login' });
    });
    const persistedLocale = localStorage.getItem('locale');
    if (persistedLocale) {
      this.$i18n.locale = persistedLocale;
    }
    await this.$kuzzle.connect();
    // Avoids showing the toast as soon as the app loads
    setTimeout(() => {
      this.checkConnection();
    }, 1000);
  },
};
</script>

<style lang="scss">
// Import Main styles for this application
@import 'assets/style';

/* Remove in 1.2 */
.v-datatable thead th.column.sortable i {
  vertical-align: unset;
}
</style>
